import { AssetTypeCode } from 'types/models/asset-type';
import SamplePoint, { SensorTagId } from 'types/models/samplePoint';

export const isTroughDirect = (samplePoint?: Pick<SamplePoint, 'sensorTags'>) =>
  samplePoint?.sensorTags?.id === SensorTagId.TROUGH_DIRECT;

export const isWirelessTrough = (samplePoint?: SamplePoint) =>
  samplePoint?.assetTypeId === AssetTypeCode.TROUGH &&
  (
    samplePoint?.sensorTags.id === SensorTagId.XTEND_TROUGH_136 ||
    samplePoint?.sensorTags.id === SensorTagId.XTEND_TROUGH_238 ||
    samplePoint?.sensorTags.id === SensorTagId.XTEND_HEATED_TROUGH_WATER_LEVEL
  );

export * from './trough-capacity';
export * from './trough-level';
